import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = {
  key: 0,
  class: "flex-center py-10"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger mb-4"
}
const _hoisted_4 = { class: "widget edit-card" }
const _hoisted_5 = { class: "stats-grid" }
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "text-grey-600 mb-4" }
const _hoisted_8 = { class: "stat-progress" }
const _hoisted_9 = { class: "stat-value" }
const _hoisted_10 = { class: "text-grey-600 mb-4" }
const _hoisted_11 = { class: "stat-progress" }
const _hoisted_12 = { class: "stat-value" }
const _hoisted_13 = { class: "text-grey-600 mb-4" }
const _hoisted_14 = { class: "widget edit-card" }
const _hoisted_15 = {
  key: 0,
  class: "flex gap-3 mb-4",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "text-center text-grey-500 py-5"
}
const _hoisted_18 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_19 = {
  key: 3,
  class: "text-center text-grey-500 py-5"
}
const _hoisted_20 = { key: 4 }
const _hoisted_21 = { class: "transaction-body" }
const _hoisted_22 = { class: "font-semibold mb-1" }
const _hoisted_23 = { class: "text-sm text-grey-600 mb-0" }
const _hoisted_24 = { key: 0 }

import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import MemberInfoHeader from '@/components/collectivites/MemberInfoHeader.vue';
import membersService from '@/services/membersService';
import { formatAmount, formatDateFrench } from '@/utils/formatters';


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectiviteMembreUtilisation',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const memberId = computed(() => Number(route.params.id));
const member = ref<any>(null);
const wallet = ref<any>(null);
const cartes = ref<any[]>([]);
const transactions = ref<any[]>([]);
const loading = ref(false);
const loadingTransactions = ref(false);
const errorMessage = ref('');

function goBack() {
    router.push({ name: 'collectivites-membres' });
}

async function loadAll() {
    if (!memberId.value) return;
    loading.value = true;
    errorMessage.value = '';
    try {
        const [m, w, c] = await Promise.all([
            membersService.getMember(memberId.value),
            membersService.getMemberWalletInfos(memberId.value).catch(() => null),
            membersService.getMemberCartes(memberId.value).catch(() => ({ cartes: [] } as any)),
        ]);
        member.value = m;
        wallet.value = w;
        cartes.value = c?.cartes || [];

        if (cartes.value.length > 0) {
            loadTransactions(cartes.value[0].id);
        }
    } catch (e: any) {
        errorMessage.value = e?.message || 'Erreur lors du chargement.';
    } finally {
        loading.value = false;
    }
}

async function loadTransactions(carteId: number) {
    loadingTransactions.value = true;
    try {
        const res = await membersService.getMemberCarteTransactions(memberId.value, carteId, {});
        transactions.value = res?.transactions || [];
    } catch (e) {
        transactions.value = [];
    } finally {
        loadingTransactions.value = false;
    }
}

onMounted(loadAll);

const headerProgress = computed(() => {
    if (!wallet.value) return null;
    return {
        label: 'Utilisation',
        percent: wallet.value.utilise_percent ?? 0,
        valueLabel: `${Math.round(wallet.value.utilise_percent ?? 0)}%`,
    };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", { class: "d-flex align-items-center gap-4 mb-6" }, [
      _createElementVNode("button", {
        class: "btn white2",
        onClick: goBack
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: "/public/icons/icon-back.svg",
          class: "btn-icon",
          alt: ""
        }, null, -1),
        _createElementVNode("span", null, "Retour", -1)
      ]))]),
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-0" }, "Membre · Utilisation", -1))
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createVNode(MemberInfoHeader, {
      member: member.value,
      "end-date": member.value?.souscription?.date_fin,
      progress: headerProgress.value
    }, null, 8, ["member", "end-date", "progress"]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "edit-card-title" }, [
        _createElementVNode("img", {
          src: "/public/icons/icon-data.svg",
          class: "size-base",
          alt: ""
        }),
        _createTextVNode(" Wallet · Utilisation ")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "stat-label" }, [
            _createElementVNode("span", { class: "circle-medium bg-color-1000" }),
            _createTextVNode(" Solde ")
          ], -1)),
          _createElementVNode("h1", _hoisted_6, _toDisplayString(wallet.value ? _unref(formatAmount)(wallet.value.solde) + ' F' : '-'), 1),
          _createElementVNode("h5", _hoisted_7, _toDisplayString(wallet.value?.solde_percent ?? 0) + "%", 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "stat-progress-fill bg-color-1000 text-white",
              style: _normalizeStyle(`width: ${Math.max(2, Math.min(100, wallet.value?.solde_percent || 0))}%;`)
            }, _toDisplayString(Math.round(wallet.value?.solde_percent || 0)) + "% ", 5)
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "stat-label" }, [
            _createElementVNode("span", { class: "circle-medium bg-purple" }),
            _createTextVNode(" Montant utilisé ")
          ], -1)),
          _createElementVNode("h1", _hoisted_9, _toDisplayString(wallet.value ? _unref(formatAmount)(wallet.value.utilise) + ' F' : '-'), 1),
          _createElementVNode("h5", _hoisted_10, _toDisplayString(wallet.value?.utilise_percent ?? 0) + "%", 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "stat-progress-fill bg-purple text-white",
              style: _normalizeStyle(`width: ${Math.max(2, Math.min(100, wallet.value?.utilise_percent || 0))}%;`)
            }, _toDisplayString(Math.round(wallet.value?.utilise_percent || 0)) + "% ", 5)
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "stat-label" }, [
            _createElementVNode("span", { class: "circle-medium bg-green-light" }),
            _createTextVNode(" Dernier décaissement ")
          ], -1)),
          _createElementVNode("h1", _hoisted_12, _toDisplayString(wallet.value?.dernier_decaissement ? _unref(formatAmount)(wallet.value.dernier_decaissement) + ' F' : '-'), 1),
          _createElementVNode("h5", _hoisted_13, _toDisplayString(wallet.value?.dernier_decaissement_date ? _unref(formatDateFrench)(wallet.value.dernier_decaissement_date) : '-'), 1),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "stat-progress" }, [
            _createElementVNode("div", {
              class: "stat-progress-fill bg-green-light",
              style: {"width":"100%"}
            }, "100%")
          ], -1))
        ])
      ])
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createElementVNode("div", _hoisted_14, [
      _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "edit-card-title" }, [
        _createElementVNode("img", {
          src: "/public/icons/icon-data.svg",
          class: "size-base",
          alt: ""
        }),
        _createTextVNode(" Transactions ")
      ], -1)),
      (cartes.value.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartes.value, (c, i) => {
              return (_openBlock(), _createElementBlock("button", {
                key: c.id,
                class: _normalizeClass(["btn", { 'white2 active': i === 0, light2: i !== 0 }]),
                onClick: ($event: any) => (loadTransactions(c.id))
              }, _toDisplayString(c.alias || c.bloc4 || `Carte ${i + 1}`), 11, _hoisted_16))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (cartes.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Aucune carte associée à ce membre. "))
        : (loadingTransactions.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("div", { class: "loader dark" }, null, -1)
            ]))]))
          : (transactions.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Aucune transaction à afficher. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (tx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tx.id,
                    class: "transaction-row"
                  }, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "transaction-icon" }, [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-trans-recharger.svg",
                        alt: ""
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("h6", _hoisted_22, _toDisplayString(tx.libelle || tx.label || 'Transaction'), 1),
                      _createElementVNode("p", _hoisted_23, [
                        _createTextVNode(_toDisplayString(tx.created_at ? _unref(formatDateFrench)(tx.created_at) : '') + " ", 1),
                        (tx.reference)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, " · " + _toDisplayString(tx.reference), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["transaction-amount", { positive: (tx.montant || 0) > 0 }])
                    }, _toDisplayString((tx.montant || 0) > 0 ? '+' : '') + _toDisplayString(_unref(formatAmount)(tx.montant || 0)) + " F ", 3)
                  ]))
                }), 128))
              ]))
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "clear-both h-50" }, null, -1))
  ]))
}
}

})